<div *ngIf="!hidden" class="wai-alert-content" [ngClass]="type" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
  <mat-icon>{{ icon }}</mat-icon>
  <div class="wai-alert-text" fxFlex><ng-content></ng-content></div>
  <button *ngIf="!persistent" mat-button color="primary" (click)="hidden = !hidden">{{ 'INTL_CLOSE' | translate }}</button>
</div>
